import React from 'react';
import { modules, promises } from '../data/modules';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function SystemSection() {
  return <section className="bg-white px-4 py-4" data-id="element-137" data-mp="3gg5aviwskaka">
      <div className="mx-auto max-w-4xl" data-id="element-138" data-mp="3bhu0n72l3y1j">
        <div className="mb-2.5 text-center" data-id="element-139" data-mp="3bkzlub83efrz">
          <p className="mb-0.5 font-head text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-gold sm:text-sm" data-id="element-140" data-mp="36kld0qyo31sw">
            The Complete System You’ve Been Looking For
          </p>
          <h2 className="mb-1.5 font-display text-2xl uppercase leading-none tracking-wide sm:text-4xl" data-id="element-141" data-mp="2wtqrxpx5q891">
            One Complete 6-in-1 Volleyball Coaching System
          </h2>
          <div className="mb-1.5 inline-block rounded-md border border-brand-gold/60 bg-brand-navy px-3 py-1.5 text-white shadow-md" data-id="element-142" data-mp="2ntkicf4kxsf5">
            <p className="font-display text-lg uppercase leading-none tracking-wide text-white sm:text-2xl" data-id="element-143" data-mp="2it694tr8scfj">
              VOLLEYBALL COACH PRO™
            </p>
            <p className="font-head text-[11px] font-medium text-brand-gold sm:text-sm" data-id="element-144" data-mp="13z7vl3wwwcna">
              The Complete Ready-to-Use System for Professional Volleyball Coaches
            </p>
          </div>
          <p className="mx-auto max-w-3xl text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-145" data-mp="u1aauqe9gxzf">
            This isn’t another collection of random volleyball drills or basic coaching theory. It’s
            a practical system designed for experienced coaches who want to reduce preparation time
            and have organized resources ready whenever they need them. With VOLLEYBALL COACH PRO™,
            you can:
          </p>
          <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[11px] font-semibold text-brand-navy sm:text-sm" data-id="element-146" data-mp="1cr04vba79fqa">
            {promises.map(promise => <li key={promise} data-id="element-147" data-mp="1bl8o9pterw8">✔ {promise}</li>)}
          </ul>
        </div>

        <div className="grid gap-2 sm:grid-cols-2" data-id="element-148" data-mp="6ciowgr9lbv3">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="group flex gap-2.5 rounded-lg border border-brand-line bg-brand-light p-3 shadow-sm transition-colors duration-150 ease-out hover:border-brand-gold" data-id="element-149" data-mp="28yecdjciblx1">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-brand-navy font-display text-xl leading-none text-brand-gold transition-colors duration-150 ease-out group-hover:bg-brand-blue" data-id="element-150" data-mp="1u98cdt5uhro3">
                {module.num}
              </span>
              <div data-id="element-151" data-mp="1lamywcf8d2u6">
                <h3 className="font-head text-[14px] font-bold leading-tight text-brand-navy sm:text-lg" data-id="element-152" data-mp="1g9frieh025o1">
                  ✅ {module.title}
                </h3>
                <p className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-153" data-mp="1bbxh0jnc3idx">
                  {module.description}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-2.5 text-center" data-id="element-154" data-mp="35masyo7y2h89">
          <a href={OFFER_ANCHOR} className="inline-block" aria-label="Go to the purchase section" data-id="element-155" data-mp="3d8ogo7nmqs1p">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[220px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-156" data-mp="3i67u55ci70sl" />
          </a>
        </div>
      </div>
    </section>;
}